import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const submitCCPayment = async(args) => {
    console.log("IN SUBMIT CC PAYMENT", args);  
    const response = await axios.post(process.env.REACT_APP_API_URL + "/submitcc", 
    { token: args.token, 
      amount: args.amount,
      shipping: args.shipping,
      orderId : args.orderId,
      paymentType: args.paymentType,
      balanceUsed: args.balanceUsed }, 
    { headers: AuthHeader.authHeader()});
    console.log("ORDER RESPONSE" , response);  
    return response.data;
  };

  const submitCCPaymentDemo = async(args) => {
    console.log("IN SUBMIT CC PAYMENT", args);  
    const response = await axios.post(process.env.REACT_APP_API_URL + "/submitccdemo", 
    {  
      amount: args.amount,
      shipping: args.shipping,
      orderId : args.orderId,
      paymentType: args.paymentType,
      balanceUsed: args.balanceUsed }, 
    { headers: AuthHeader.authHeader()});
    console.log("ORDER RESPONSE" , response);  
    return response.data;
  };

const PaymentService = {
    submitCCPayment,
    submitCCPaymentDemo,

};
export default PaymentService;